export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export const getDeviceType = (): DeviceType => {
  const width = window.innerWidth
  
  if (width < 768) {
    return 'mobile'
  } else if (width >= 768 && width < 1024) {
    return 'tablet'
  } else {
    return 'desktop'
  }
}

export const isMobileOrTablet = (): boolean => {
  const deviceType = getDeviceType()
  return deviceType === 'mobile' || deviceType === 'tablet'
}

export const isDesktop = (): boolean => {
  return getDeviceType() === 'desktop'
}

// Additional user agent checks for more accurate mobile detection
export const isMobileUserAgent = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as unknown as { opera: string }).opera

  return /android|avantgo|blackberry|iemobile|ipad|iphone|ipod|opera mini|webos/i.test(userAgent)
}

export const shouldRestrictAccess = (): boolean => {
  return false
}